// app\utils\speechbyapi.js
'use client';
import * as Global from '@/utils/global';

// 使い方 /////////////////////////////////////////////
// ID"main-textbox"を持つテキストエリアを設置
// ID"send-button"を持つ送信ボタンを設置
// 別コンポーネントで利用する場合は setListeningTarget で対象IDを指定
// onDelaySendButton 発火時に一時的にリスニング停止される
// 再開は内容更新後テキストボックスクリアして
// setListeningActive(true)をコールする
///////////////////////////////////////////////////////

// ----------------------------
// 音声認識システム - セグメント分割無し版
// ----------------------------
const START_MAX_VOLUME  =  3.6//=  1.6//=  1.8;  //  1.3;   // 1.6;  // 1.4  発話検出 環境音の倍率を上回る時発動
const STOP_MIN_VOLUME   =  3.0//=  1.4//=  1.6;  //  1.2;   // 1.5;  // 1.6  静音判定 環境音の倍率を下回る時発動(騒音が多い環境だと2.0では下回るまでに時間がかかる) 2では低すぎた。2.3を下回ったら無音判定に上げる
const AVE_HARETSU_VOL   =  1.5;  //  =  1.2;  //  1.2;   // 1.3;  // 1.3  指定時間内のミニマムサンプルが環境音の指定倍数未満であれば切り捨てる まだ送られる大きくする→１音目が取れないから小さくする 破裂判定されやすくUPした
const AVE_RAW_VOLUME    =  1.5;  //  =  1.2;  //  1.2;   // 1.3;  // 1.3  平均が環境音の倍率であれば切り捨てる ※ぼそぼそつぶやきの無効化を強化する 会話の一部欠損。徐々に小さい声になる対策で2.2まで下げる。物音でもサーバーに要求しすぎ2.2にやや上げる
const MIN_RECORD_MS             =  1200; //  600;   // 600;  // 1000 既定の判定時間で最低秒録音で判定する短いのは、誤入力リスクが上がる
const SPLIT_TIME                =  1000;  //  400;   // 400;  // 500  無音を継続監視して停止する（やっちゃった等、小音タイム以上を考慮）(認識精度上げるときは長文になるよう大きくする) ※0.4秒以上はないと、長文判定に満たない不完全推論が多発。小さくするなら音が小さいもを破棄する
// ----------------------------                    
const MIN_HARETSU_MS            =  400;  //  400;   // 400;  // 400  発音判定から、破裂音判定を開始する待ち時間。「やっぱり」等２音目までの0.4秒以上ないとうまく判定できない
const MAX_HARETSU_MS            =  600;  //  600;   // 600;  // 600  発音判定から、破裂音判定を終了する待ち時間
// ----------------------------                    
const MAX_RECORDING_MS = 1000   *  55;   //  55;    // 55;   // 55   秒制限
const MAX_HISTORY_COUNT = 60    *  30;   //  60;    // 60;   // 60   秒デシベル履歴の保有個数(60fps)*秒数
const BASENOISE_MUST_COUNT = 60 *  0.2;  //  0.5;   // 1;    // 判定に必要な最小環境音サンプリング数(60fps)
const BASENOISE_MAX_COUNT = 60  *  3;    //  3;     // 3;    // 4秒デシベル履歴の保有個数(60fps) * 秒数 素早くベース環境音に適応する為短い時間がよい
// ----------------------------                    
const VOICE_DELAY_TIME = 1000 * 1.5;     //  1;    //  2;    //  1;     // 3;    // 4秒 ボイス入力時 送信ボタン自動押下遅延時間
const DIRECT_SEND_TEXT_LENGTH   =  100;  // 200;  // 500;  // テキストボックスの文字数がこの値を超えたら、次の文字起こし反映時に直ちに送信する
// ----------------------------                    
const MEDIA_RECORD_TIMESLICE    =  1000; //  1000;  // 1000; // 1000メディアレコーダー断片時間
const WARMUP_START_DELAY        =  1000; //  1000;  // 1000; // 1000ノイズ取得遅延時間
const MIC_FIND_CYCLE            =  1500; //  1500;  // 1500; // 1500マイク再接続サイクル
const MIC_ERROR_RECONNECT_DELAY =  500;  //  0にすると従来どおり即時再接続判定
// ----------------------------                    
const NORMARIZE_BASE_ADDITIONAL =  500; //  1000;  // 1000; // 1500 小さいほうが、環境音が大きい中で無音判定されやすい。環境音の掛け率基準値をスライド調整する。掛け率の適正値に大きく影響する

let mediaRecorder = null;
let isListening = false;
let audioChunks = [];
let audioBlob = null;
let silenceStart = null;
let recordingStart = null;
let audioContext = null;
let analyser = null;
let audioMonitorRAF = null;
let globalStream = null;
let sourceNode = null;
let maxRecordingTimeout = null;
let rawdbHistory = [];
let rawdbBaseNoise = [];
let isRecordingAborting = false;
let cntHttpPosting = 0;
let micWarmupStart = null;
let isMicMonitoring = false;
let micErrorStart = null;
// ----------------------------
let sendButtonReserve = null;
let timerSendButtonId = null;
let confirmedTextMemory = "";
// ----------------------------
let globalUserGUID = null;
let globalDomain = null;
let targetTextboxId = "main-textbox";
let targetSendButtonId = "send-button";
let targetIndicatorId = "rec-indicator";

export function setListeningTarget(textboxId = "main-textbox", sendButtonId = "send-button", indicatorId = "rec-indicator") {
    targetTextboxId = textboxId;
    targetSendButtonId = sendButtonId;
    targetIndicatorId = indicatorId;
}

function getTargetTextbox() {
    return document.getElementById(targetTextboxId);
}

function getTargetSendButton() {
    return document.getElementById(targetSendButtonId);
}

export function setglobalUserInfo(user_guid, domain) {
    globalUserGUID = user_guid;
    globalDomain = domain
}

export function setListeningEngine(enable) {

    cntHttpPosting = 0;
    if (enable) {
        if (!audioContext) audioContext = new AudioContext();
        if (globalStream) {
            // console.warn("[２重getUserMedia起動エラー]");
        }
        navigator.mediaDevices.getUserMedia({ audio: true })
            .then(stream => {
                console.log("[🎤 マイク接続成功]");
                if (isListening) setIndicatorColor("silent");
                globalStream = stream;

                // MediaRecorderを作成・開始
                mediaRecorder = new MediaRecorder(globalStream, { mimeType: "audio/webm; codecs=opus" });
                //mediaRecorder.start();
                //console.log("[録音開始]");

                mediaRecorder.onstart = () => {
                    recordingStart = Date.now();
                }

                mediaRecorder.ondataavailable = (e) => {
                    if (!isRecordingAborting) {
                        if (e.data && e.data.size > 0) {
                            if (e.data && e.data.size > 0) {
                                audioChunks.push(e.data);
                            }
                        }
                    }
                };

                mediaRecorder.onstop = () => {
                    if (!isRecordingAborting) {
                        if (audioChunks.length > 0) {
                            audioBlob = new Blob(audioChunks, { type: "audio/webm" });
                            audioChunks = [];
                            finalizeRecording();
                        }
                        RecordingClear();
                        isRecordingAborting = false;
                    }
                    recordingStart = null;
                    clearTimeout(maxRecordingTimeout);
                };
                setTimeout(() => {
                    try {
                        // mediaRecorder起動後に呼び出し
                        analyser = audioContext.createAnalyser();
                        sourceNode = audioContext.createMediaStreamSource(globalStream);
                        sourceNode.connect(analyser);

                        // 音声遅延取得に開始時間を記録する
                        micWarmupStart = Date.now();
                        // 起動時初回呼び出し
                        monitorAudioLevel();
                    } catch {
                        // 通常開始直後のキャンセルなど
                        // 何もしない
                    }

                }, 500);

            })
            //.catch(err => console.error("[マイク取得エラー]", err));
            .catch(() => {
                console.log("[⚠️マイク切断検出]");
                MediaRecorderStop(true);
                attemptMicrophoneAccess();
            });

    } else {
        // 単純マイク切断の場合があるため、リスニングフラグを変更しない
        //isListening = false;
        console.log("[🎤 マイク接続終了]");
        setIndicatorColor("stop");
        MediaRecorderStop(true)
        setIndicatorColor("stop");

        if (globalStream) {
            globalStream.getTracks().forEach(track => track.stop());
            globalStream = null;
        }

        if (audioMonitorRAF) {
            cancelAnimationFrame(audioMonitorRAF);
            audioMonitorRAF = null;
        }

        if (sourceNode) {
            sourceNode.disconnect();
            sourceNode = null;
        }
        if (analyser) {
            analyser.disconnect();
            analyser = null;
        }
        if (audioContext) {
            audioContext.close();
            audioContext = null;
        }
    }
}

export function setListeningActive(active) {
    // 切り替え時はバッファを切り捨て
    // フラグ制御のみ
    RecordingClear();
    if (active && !isListening) {
        // setIndicatorColor("listening");
        try {
            isListening = true;
            // 初期テキスト記憶
            let textbox = getTargetTextbox();
            confirmedTextMemory = textbox ? textbox.value : "";
            // スタート時点でタイマー延長しておく
            startDelaySendButton(VOICE_DELAY_TIME);
        } catch {
            // 何もしない
        }
        if (!recordingStart) setIndicatorColor("silent");
    } else if (active && isListening) {
        if (!recordingStart) setIndicatorColor("silent");
    } else if (!active && isListening) {
        isListening = false;
        stopDelaySendButton();
        setIndicatorColor("stop");
    } else if (!active) {
        stopDelaySendButton();
        setIndicatorColor("stop");
    }
    //startListening();
    setTimeout(() => {
        startListening();
    }, 500);
}

function setIndicatorColor(state) {
    const el = document.getElementById(targetIndicatorId);
    if (!el) return;
    if (state === "listening") el.style.backgroundColor = "red";
    else if (state === "silent") el.style.backgroundColor = "#ddd";
    else if (state === "stop") el.style.backgroundColor = "transparent";
}

function attemptMicrophoneAccess() {
    console.log("[🔁マイク未検出]再接続中...");
    navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
            console.log("[🎤 マイク接続成功 - リトライ]");
            globalStream = stream;
            setListeningEngine(true); // 再起動処理
        })
        .catch(() => {
            //console.warn("[🔁マイク未検出]再試行中...", err);
            setTimeout(attemptMicrophoneAccess, MIC_FIND_CYCLE); // 永続リトライ
        });
}

function MediaRecorderStart() {
    isRecordingAborting = false;
    try {
        mediaRecorder.start(MEDIA_RECORD_TIMESLICE);
        setIndicatorColor("listening");
    } catch (err) {
        console.warn("[StartRecordingエラー]", err);
        setListeningEngine(false);
        return
    }
}
function MediaRecorderStop(isabort) {
    isRecordingAborting = isabort;
    RecordingStop();
    try {
        if (mediaRecorder && mediaRecorder.state === "recording") {
            mediaRecorder.stop();
            setIndicatorColor("silent");  // 無音状態
        }
    } catch (err) {
        console.warn("[MediaRecorderStopエラー]", err);
        setListeningEngine(false);
        return
    }
    // 即時終了指示の場合は、メモリをクリアする
    if (isabort) {
        RecordingClear();
    }
}

// 1秒間に60回程度実行される
function monitorAudioLevel() {

    // if (audioChunks.length == 0) console.log(`[⌛リスニング待機中]`);
    if (!analyser) {
        //console.warn("[monitorAudioLevel] analyserが未初期化です");
        return;
    }

    // レコーディング中は全ての送信ボタン予約をキャンセルする
    if (recordingStart) stopDelaySendButton();

    const dB = getVolumeDb();

    // ✅ dB算出後にpush
    if (recordingStart && isMicMonitoring && getRawVol(dB) > 0) {
        rawdbHistory.push(getRawVol(dB));
        if (rawdbHistory.length > MAX_HISTORY_COUNT) rawdbHistory.shift();
        // console.log(`[monitorAudioLevel] : rawdbHistory個数: ${rawdbHistory.length}`);
    }

    if (isMicMonitoring && isListening) {
        rawdbBaseNoise.push(getRawVol(dB));
        if (rawdbBaseNoise.length > BASENOISE_MAX_COUNT) rawdbBaseNoise.shift();
    }

    const now = Date.now();
        
    let minBaseNoise = getMinSampling(rawdbBaseNoise, rawdbBaseNoise.length / 10);
    //console.log(`getRawVol:${getRawVol(dB) }`);

    // 環境音が既定秒数以上そろっている場合のみ判定開始
    if (isMicMonitoring && rawdbBaseNoise.length >= BASENOISE_MUST_COUNT) {
        if (!recordingStart && isListening) {
            if (getRawVol(dB) > START_MAX_VOLUME * minBaseNoise) {
                if (mediaRecorder && isListening && mediaRecorder.state != "recording") {
                    //console.log(`[‼️START] 発話開始検出: Base:${minBaseNoise} * ${START_MAX_VOLUME} = ${Math.round(minBaseNoise * START_MAX_VOLUME)} < Raw:${getRawVol(dB)}`);
                    console.log(`[‼️START] 発話開始検出`);
                    MediaRecorderStart();
                }
            }
            silenceStart = null;
        } else if (recordingStart && isListening && !isRecordingAborting) {
            // 現在の瞬間音量
            const rawVol = getRawVol(dB)
            // 発音音源の小さい音順で6割のノイズ平均値を求める
            // const rawdbMinAvb = getMinSampling(rawdbHistory, Math.round(rawdbHistory.length * 3 / 5));
            // 発音音源の平均値
            const rawdbAveAvb = getAveSampling(rawdbHistory);

            // 音量判定
            if ((now - recordingStart) > MAX_RECORDING_MS) {
                console.log(`[⏹️STOP] 録音停止 最大録音時間到達送信`);
                MediaRecorderStop(false);
            } else if (rawVol > (STOP_MIN_VOLUME * minBaseNoise)) {
                // 既定値以上の音量検出で無音検知タイマーをクリア
                silenceStart = null;
            } else if (!silenceStart && rawVol < (STOP_MIN_VOLUME * minBaseNoise)) {
                //} else if (!silenceStart) {
                // 既定値以下の検知で直ちに無音タイマー開始
                // 無音開始時間を記憶
                silenceStart = now;
            } else if (recordingStart && (now - recordingStart) > MIN_HARETSU_MS && (now - recordingStart) < MAX_HARETSU_MS && (rawdbAveAvb < AVE_HARETSU_VOL * minBaseNoise)) {
                // 破裂音判定、発話ノイズ平均が送信下限を下回っていた場合。発話キャンセル
                console.log(`[🎉STOP] 破裂音検知(${(now - recordingStart)}ms): Base:${minBaseNoise} * ${AVE_HARETSU_VOL} = ${Math.round(minBaseNoise * AVE_HARETSU_VOL)} > Ave:${rawdbAveAvb}`);
                MediaRecorderStop(true);
            } else if (silenceStart && rawVol < (STOP_MIN_VOLUME * minBaseNoise) && recordingStart && (now - silenceStart) > SPLIT_TIME && (now - recordingStart) > MIN_RECORD_MS) {
                // 無音検知 かつ 最低レコード時間までの間に、発音検知が発生しなかった場合
                console.log(`[🧊STOP] 無音確定(${(now - recordingStart)}ms): Base:${minBaseNoise} * ${STOP_MIN_VOLUME} = ${Math.round(minBaseNoise * STOP_MIN_VOLUME)} > Now:${rawVol}`);
                MediaRecorderStop(false);
            }
            // 破裂検知タイム（MAX_HARETSU_MS）を超えてレコーディングが継続していて無音検知前の場合、送信ボタンを延長する
            if (isListening && recordingStart && !silenceStart && (now - recordingStart) > MAX_HARETSU_MS) {
                console.log(`[⏯️破裂判定クリア送信ボタン延長...] `);
                if (sendButtonReserve) startDelaySendButton(VOICE_DELAY_TIME);
            }
        }
    } else if (isMicMonitoring) {
        console.log(`[👂環境音収集中]`);
    }
    // キーボード入力検知
    checkKeyboardInput();
    // SendButton監視
    onDelaySendButton();
    // 再帰予約
    startListening();
}

function startListening() {
    //if (analyser && isListening) {
    //    audioMonitorRAF = requestAnimationFrame(monitorAudioLevel);
    //}
    if (isListening) {
        try {
            audioMonitorRAF = requestAnimationFrame(monitorAudioLevel);
        } catch (err) {
            console.warn("[⚠️サンプリング開始エラー]", err);
        };
    }
}

function finalizeRecording() {

    // console.log(`[finalizeRecording] : rawdbHistory個数: ${rawdbHistory.length}`);

    //let rawdbAvg = rawdbHistory.reduce((acc, v) => acc + v, 0) / (rawdbHistory.length || 1);
    let rawdbAvg = getAveSampling(rawdbHistory);

    let minBaseNoise = getMinSampling(rawdbBaseNoise, rawdbBaseNoise.length / 10);

    if (rawdbAvg < AVE_RAW_VOLUME * minBaseNoise) {
        console.log(`[❓HTTP送信検査] 破棄: Base:${minBaseNoise} * ${AVE_RAW_VOLUME} = ${Math.round(minBaseNoise * AVE_RAW_VOLUME)} > Ave:${rawdbAvg.toFixed(0)}`);
        // リスニング再開
        startListening();
        return;
    } else {
        console.log(`[❓HTTP送信検査] 実行: Base:${minBaseNoise} * ${AVE_RAW_VOLUME} = ${Math.round(minBaseNoise * AVE_RAW_VOLUME)} < Ave:${rawdbAvg.toFixed(0)}`);
        sendToTransVoiceAPI(audioBlob);
    }
    RecordingClear();
}

function RecordingClear() {
    rawdbHistory = [];
    audioChunks = [];
    audioBlob = null;
    RecordingStop();
}

function RecordingStop() {
    silenceStart = null;
    micWarmupStart = null;
}
function sendToTransVoiceAPI(blob) {
    console.log("[▶️API呼び出し中....]");
    cntHttpPosting += 1;
    if (cntHttpPosting > 0) stopDelaySendButton();
    const reader = new FileReader();
    reader.onloadend = () => {
        const base64webm = reader.result.split(',')[1];
        try {

            // alert(
            // JSON.stringify({
            //     user_guid: globalUserGUID,
            //     base64webm: base64webm
            // })
            // );
            fetch(`${Global.getApiBaseUrl()}/voice_recording/voicetransrate`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    // user_guid: globalUserGUID,
                    // base64webm: base64webm
                    base_interface: {
                        user_guid: globalUserGUID,
                        user_domain: globalDomain ,
                        ip_address: window.location.hostname,
                        user_agent: navigator.userAgent,
                    },
                    body_data: {
                        base64webm: base64webm,
                    }                    
                })
            })
                .then(response => response.json())
                .then(data => {
                    console.log("[✅文字起こし結果]", data.text);
                    const text = data.text || "";
                    const textbox = getTargetTextbox();
                    if (textbox && text !== "") {
                        const newText = textbox.value + (textbox.value ? " " : "") + text;
                        setNativeValue(textbox, newText);
                        if (newText.length >= DIRECT_SEND_TEXT_LENGTH && !recordingStart) {
                            clickSendButtonNow();
                        }
                    }
                })
                .catch(error => {
                    console.error("[エラー]Abort処理", error);
                    MediaRecorderStop(true);
                }).finally(() => {
                    cntHttpPosting -= 1;
                    if (cntHttpPosting == 0 && !recordingStart) startDelaySendButton(VOICE_DELAY_TIME);
                });
        } catch (err) {
            console.error("[エラー]Abort処理", err);
            cntHttpPosting -= 1;
            if (cntHttpPosting == 0 && !recordingStart) startDelaySendButton(VOICE_DELAY_TIME);
            MediaRecorderStop(true);
        }
    };
    reader.readAsDataURL(blob);
}
function setNativeValue(element, value) {
    let lastValue = element.value;
    element.value = value;
    confirmedTextMemory = value;

    let event = new Event("input", { bubbles: true });
    let tracker = element._valueTracker;
    if (tracker) {
        tracker.setValue(lastValue);
    }
    element.dispatchEvent(event);
}

// 遅延タイマーを開始
function startDelaySendButton(delayTime) {
    //console.log(`[⌛startDelaySendButton: ${cntHttpPosting}]`);
    const sendButton = getTargetSendButton();
    if (isListening && sendButton) {
        sendButtonReserve = Date.now() + delayTime;
    }
}

// 遅延タイマーを削除
function stopDelaySendButton() {
    //console.log(`[⌛stopDelaySendButton: ${cntHttpPosting}]`);
    sendButtonReserve = null;
}

export function cancelListeningAutoSend() {
    stopDelaySendButton();
}

// ループ内からコールされ時間経過によりボタンクリックを実行する
function onDelaySendButton() {
    if (recordingStart) {
        stopDelaySendButton();
        return;
    }
    if (sendButtonReserve && Date.now() >= sendButtonReserve) {
        const textbox = getTargetTextbox();
        if (textbox && textbox.value != '') {
            const sendButton = getTargetSendButton();
            if (isListening && sendButton) {
                sendButton.dispatchEvent(new Event("click", { bubbles: true, cancelable: true }));
                setListeningActive(false); // UIから再開されるまでリスニングをストップ
                stopDelaySendButton();
            }
        }
    }
}
function clickSendButtonNow() {
    const sendButton = getTargetSendButton();
    if (isListening && sendButton) {
        sendButton.dispatchEvent(new Event("click", { bubbles: true, cancelable: true }));
        setListeningActive(false); // UIから再開されるまでリスニングをストップ
        stopDelaySendButton();
    }
}

// 最小値順でのn個の平均値を求める
function getMinSampling(arr, n) {
    if (arr.length === 0) return 0;
    const sorted = [...arr].sort((a, b) => a - b); // 小さい順に並び替え
    const minN = sorted.slice(0, n); // 最初のn個を取り出す
    const ave = minN.reduce((acc, v) => acc + v, 0) / (minN.length || 1); // 平均計算
    return Math.round(ave);
}

// 最小値順でのn個の平均値を求める
function getAveSampling(arr) {
    const ave = arr.reduce((acc, v) => acc + v, 0) / (arr.length || 1)
    //console.log(`ave:${Math.round(ave)}`);
    return Math.round(ave);
}

function getRawVol(db) {
    // 音量の計算
    const rawVol = parseInt(Math.pow(10, db / 20));
    // 通常のベース音が450程度である。
    // 値が小さい時の上昇率が高いため鈍らせるため、1500を足してBASEが100程度になるように調整する
    //return Math.round((rawVol + 1500) / 20)
    return Math.round((rawVol + NORMARIZE_BASE_ADDITIONAL) / 20)
}

function getVolumeDb() {
    if (!analyser) return 0;
    try {
        const buffer = new Uint8Array(analyser.fftSize);
        analyser.getByteTimeDomainData(buffer);
        let sum = 0;
        for (let i = 0; i < buffer.length; i++) {
            const deviation = buffer[i] - 128;
            sum += deviation * deviation;
        }
        const rms = Math.sqrt(sum / buffer.length);
        const rawDb = 20 * Math.log10(rms / 128);
        const db = rawDb + 100;

        // 🟡 追加：マイク起動直後はまだ安定していないので、例外判定を保留する
        if (!isMicMonitoring && Date.now() - micWarmupStart < WARMUP_START_DELAY) {
            console.log(`[⌛安定待ち時間例外遅延待機]`);
            if (db > 0) MicMonitorStart();
            return 0; // 安定まで待つ（例外も発生しない）
        } else {
            if (!isFinite(db)) {
                // console.warn("[⚠️isFinite(db)マイク無効判定]");
                throw new Error("マイク無効判定");
            } else if (!isMicMonitoring) {
                MicMonitorStart();
            }
            micErrorStart = null;
            return db;
        }
        //return db;
    } catch (e) {
        //micWarmupStart = Date.now();
        const now = Date.now();
        if (!micErrorStart) micErrorStart = now;
        if (MIC_ERROR_RECONNECT_DELAY > 0 && now - micErrorStart < MIC_ERROR_RECONNECT_DELAY) {
            console.warn("[⚠️マイク一時異常] 再接続判定を保留:", e.message);
            return 0;
        }
        micErrorStart = null;
        console.warn("[⚠️マイク異常] 再接続を試行:", e.message);
        MicMonitorStop()
        setListeningEngine(false);
        setTimeout(() => setListeningEngine(true), MIC_FIND_CYCLE);
        return 0;
    }
}
function MicMonitorStart() {
    console.log("[🎙️マイクモニタリング開始]");
    micErrorStart = null;
    isMicMonitoring = true;
}
function MicMonitorStop() {
    micErrorStart = null;
    isMicMonitoring = false;
}

function checkKeyboardInput() {
    //console.log("⏱️入力検知チェック");

    // 入力による文字列変化を確認
    let textbox = getTargetTextbox();
    if (textbox && confirmedTextMemory != textbox.value) {
        // 入力差異検知
        confirmedTextMemory = textbox.value;
        // 確定文字としてテキストボックスに戻す
        //setNativeValue(textbox, confirmedTextMemory);
        setNativeValue(textbox, textbox.value);
        return true;
    }
    return false;
}
